<template lang="pug">
  .products-inventory
    .background-header.white
      v-container.pa-0.white(style="max-width:600px")
        //- Sticky save
        .sticky-header-container(style="top:-1px" v-if="editedInventory.length > 0" :style="editedInventory.length > 0 ? 'height:60px' : '' ")
          .sticky-header
            div.pa-4(flat outlined style="background-color:var(--v-successT08);")
              v-row(no-gutters)
                v-col.text-start.align-self-center(cols="6")
                  div.p2.primary500--text {{ $t('have_made_count_changes', { count: editedInventory.length }) }}
                v-col(align='right')
                  v-btn.button-Aa-medium(text height="32" color='success500' :disabled="isSaving" @click='clearTask()') {{ $t('cancel') }}
                  v-btn.button-AA-medium.white--text(depressed color="success500" height="32" :loading="isSaving" @click="saveTask()") {{ $t('save') }}
        div.d-flex(v-if="parentProduct")
          v-btn(icon @click="back()")
            v-icon(color="black") mdi-arrow-left
          div.black--text.ml-4.my-auto
            p.h6.basic1000--text.mb-0 {{ parentProduct.name }}
        div.pt-3.px-3.mx-2.my-2
          div.d-flex.align-center
            v-text-field(v-model="searchFilter.searchText" hide-details dense outlined :placeholder="$t('search_product')" height="40" background-color="basic200")
              template(v-slot:append)
                eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
            v-btn.label.px-0.ml-2(v-if="!pid" color="transparent" text @click="exportCsv")
              eva-icon.mt-1.mr-1(name="external-link-outline" :fill=" $vuetify.theme.themes[$theme].primary400" width="14")
              div.primary400--text {{ $t('export') }}
          div.d-flex.mt-3
            y-checkbox.pa-0.ma-0(v-if="!parentProduct" v-model="searchFilter.hideSubProduct" hide-details)
              template(v-slot:label)
                div.s2.primary--text.pl-1 {{ $t('hide_variant_inventory') }}
            v-spacer
            v-menu(left :offset-y="true")
              template(v-slot:activator='{ on }')
                v-btn.label.px-0(small color="primary400" text v-on="on")
                  v-icon.mr-2(color="primary400" size="14") {{ sortSelections[searchFilter.sortIndex].icon }}
                  | {{ sortSelections[searchFilter.sortIndex].name }}
              v-list
                v-list-item.my-n2(v-for="(sort, index) in sortSelections" :key="sort.order" @click="searchFilter.sortIndex = index")
                  v-list-item-title.s2.basic800--text
                    v-icon.mr-2(color="basic800" small) {{ sort.icon }}
                    | {{ sort.name }}
    v-container.pa-0.mb-4(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(width="2" size="50" color="primary" indeterminate)
      .contain-layout(v-else)
        v-layout.my-6(v-if="!products")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption {{ $t('products_not_found') }}
        .items-layout(v-else).mx-2
          .list-item.my-2(three-line)
            template(v-for='product in products')
              edit-product-item-quantity(:product="product" :pid="pid" @editQuantity="updateTask($event)" :key="product.id" :focused="editedInventory.some(x => x.id==product.id)" :edited="editedInventory[editedInventory.findIndex(x => x.id==product.id)]")
              v-divider.basic300
        //-.debug
          //- p {{ filterParams }}
          //- p {{ parentProduct}}
          //- p {{ products }}
          //- p {{ pid }}
          //- p {{ $route.path }}
      //- y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
      y-pagination-custom.ma-4(v-if="count > 0" v-model="page" :parentPageSize.sync="pageSize" :count="count" :text="$t('show_stocks')")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import EditProductItemQuantity from '@/components/EditProductItemQuantity.vue'

export default {
  name: 'ProductsInventory',
  components: { EditProductItemQuantity },
  props: ['company', 'pid'],
  data: () => ({
    isFetching: false,
    isSaving: false,
    parentProduct: null,
    products: [],
    page: 1,
    pageSize: 20,
    count: 0,
    searchFilter: {
      sortIndex: 0,
      searchText: '',
      hideSubProduct: false,
    },
    editedInventory: [],
    searchCountDown: null,
  }),
  mounted () {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
    this.fetchProducts()
  },
  computed: {
    ...mapState('user', ['user', 'member']),
    sortSelections () {
      const p = 'inventory_qty'
      return [
        {name: this.$t('low_stock'), order: p, icon: 'mdi-sort-ascending'},
        {name: this.$t('high_stock'), order: '-' + p, icon: 'mdi-sort-descending'},
        {name: this.$t('name'), order: null, icon: 'mdi-sort'},
      ]
    },
    filterParams () { // TODO: Use method instead
      return {
        company: this.company.id,
        page: this.page,
        page_size: this.pageSize,
        inventory_enabled: true,
        bundle: false,
        include_sub_product: !this.searchFilter.hideSubProduct,
        search: this.searchFilter.searchText,
        ordering: this.sortSelections[this.searchFilter.sortIndex].order
      }
    },
  },
  watch: {
    page (val) {
      history.pushState({}, null, location.pathname + '?page=' + val)
      if (!this.isFetching) {
        this.fetchProducts()
      }
    },
    pageSize () {
      this.page = 1
      this.fetchProducts()
    },
    searchFilter:{
      handler(){
        if (this.searchCountDown) {
          clearTimeout(this.searchCountDown)
        }
        this.searchCountDown = setTimeout(() => {
          this.page = 1
          this.fetchProducts()
        }, 200)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    back () {
      this.$router.go(-1)
    },
    endpoint () {
      if (!this.pid) return '/products'
      return `/products/${this.pid}/addons`
    },
    async fetchProducts() {
      // Fetch parent
      this.isFetching = true
      if (this.pid && !this.parentProduct) {
        await this.axios.get(`/products/${this.pid}/?expand=variants,options`).then(resp => {
          this.parentProduct = resp.data
        }).catch(() => {})
      }
      // Fetch child
      this.$axios.get(this.endpoint(), { params: this.filterParams })
        .then((response) => {
          this.products = (this.parentProduct && this.parentProduct.has_variants) ? this.parentProduct.variants.map(m => m.product) : response.data.results
          // this.totalPage = Math.ceil(response.data.count/this.pageSize)
          this.count = response.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    updateTask(product){
      var index = this.editedInventory.findIndex(x => x.id==product.id);
      if (index === -1) {
        this.editedInventory.push(product)
      } else if (product.quantity !== null){
        this.editedInventory[index].quantity = product.quantity
      } else{
        this.editedInventory.splice(index, 1);
      }
    },
    async saveTask () {
      this.isSaving = true
      for (const product of this.editedInventory) {
        await this.axios.patch(`/products/${product.id}/`, { inventory_qty: product.quantity }).catch(() => {})
      }
      this.isSaving = false
      this.clearTask()
    },
    clearTask() {
      this.editedInventory = []
      this.products = []
      this.fetchProducts()
    },
    exportCsv () {
      let queryString = Object.keys(this.filterParams).map(key => key + '=' + this.filterParams[key]).join('&')
      let exportDomain = 'https://export-test.yezza.io'
      if (process.env.VUE_APP_ENV === 'prod') {
        exportDomain = 'https://export.yezza.io'
      }
      this.$axios.post(`/users/${this.user.id}/request_otk/`)
        .then(response => {
          const exportUrl = `${exportDomain}/products/export_csv/?${queryString}&key=${response.data.key}`
          if (this.$isMobile) {
            window.open(exportUrl)
          } else {
            location.href = exportUrl
          }
        })
        .catch(() => {})
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  height: 100px;
}
.sticky-header{
  position: fixed;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
}

</style>

<i18n>
{
  "en": {
    "search_product": "Search product",
    "hide_variant_inventory": "Hide variant and add-on inventory",
    "low_stock": "Low stock",
    "high_stock": "High stock",
    "have_made_count_changes": "You have made {count} changes",
    "show_stocks": "Show stocks"
  },
  "id": {
    "search_product": "Cari produk",
    "hide_variant_inventory": "Sembunyikan varian dan inventaris tambahan",
    "low_stock": "Stok paling sedikit",
    "high_stock": "Stok paling tinggi",
    "have_made_count_changes": "Anda telah membuat {count} perubahan",
    "show_stocks": "Tampilkan stok"
  }
}
</i18n>